/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-closing-bracket-location */
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { withTranslation } from 'react-i18next';
import InputLabelMobile from '../../Common/Profile/InputLabelMobile';

import { formValidator } from '../../../AppUtil/AppUtil';
import { toastOnConfirmChanges } from '../../../SweetAlertUtil/util';
import { commonStyleForEditPersonalInfo } from '../../Common/CommonStyle';
import BaseForm from './BaseForm';
import { ta } from 'date-fns/locale';
import ExpandIcon from '../../Common/Profile/SvgIcon/ExpandIcon';
import { hot } from 'react-hot-loader';

const PATTERN = window.AppConfig.REGULAR_EXPRESSION;

class EditProfile extends React.Component {
	constructor(props) {
		super(props);
		this.inputLabel = React.createRef();
		this.state = {
			_disableSaveButton: true,
			_editProfileForm: {
				address: {
					value: this.props.user.address || '',
					placeholder: 'label.your_address',
					isValid: true,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'error_message.required_address'
						}
					},
					error_text: ''
				},
				region: {
					value: this.setLenderState(this.props.user.state) || '',
					placeholder: 'label.region',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'error_message.required_region'
						}
					},
					error_text: ''
				},
				barangay: {
					value: this.props.user.barangay || '',
					placeholder: 'label.barangay',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'error_message.required_barangay'
						}
					},
					error_text: ''
				},
				city: {
					value: this.props.user.city || '',
					placeholder: 'label.city',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'error_message.required_city'
						}
					},
					error_text: ''
				},
				postalCode: {
					value: this.props.user.postal_code || '',
					placeholder: 'label.postal_code',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'error_message.required_postal_code'
						},
						pattern: {
							value: PATTERN.ZIP,
							errorMsg: 'error_message.invalid_zip'
						}
					},
					error_text: ''
				}
			}
		};
	}

	setLenderState = value => {
		for (let i = 0; i <= this.props.supportedStates.length; i++) {
			if (this.props.supportedStates[i]?.value === value) {
				return this.props.supportedStates[i];
			}
		}
	};

	handelInputChange = e => {
		this.setState({
			_disableSaveButton: false
		});
		const name = e.target.name;
		const value = e.target.value;
		const editProfileForm = {
			...this.state._editProfileForm
		};
		const updatedFormElement = {
			...editProfileForm[name]
		};
		updatedFormElement.value = value;
		updatedFormElement.isValid = true;
		updatedFormElement.error_text = '';
		editProfileForm[name] = updatedFormElement;
		this.setState({
			_editProfileForm: editProfileForm
		});
	};

	onSubmitHandler = e => {
		e.preventDefault();
		if (!this.formValidator()) {
			return false;
		}

		// Check if the user has made any changes
		if (
			this.props.user.address == this.state._editProfileForm.address.value &&
			this.props.user.barangay == this.state._editProfileForm.barangay.value &&
			this.props.user.city == this.state._editProfileForm.city.value &&
			this.props.user.postal_code == this.state._editProfileForm.postalCode.value &&
			this.props.user.state == this.state._editProfileForm.region.value.value
		) {
			return false;
		}

		const editProfileForm = {
			...this.state._editProfileForm
		};
		const user = {
			barangay: editProfileForm.barangay.value,
			state: String(editProfileForm.region.value.value),
			city: editProfileForm.city.value,
			postal_code: editProfileForm.postalCode.value,
			address: editProfileForm.address.value
		};
		toastOnConfirmChanges(this.props.onSubmit, user, this.props.closeProfileScreen);
	};

	handleStateChange = (_event, value) => {
		const infoForm = {
			...this.state._editProfileForm
		};
		const updatedFormElement = {
			...infoForm.region
		};
		updatedFormElement.value = value;
		updatedFormElement.isValid = true;
		updatedFormElement.error_text = '';
		infoForm.region = updatedFormElement;
		this.setState({
			_editProfileForm: infoForm,
			_disableSaveButton: false
		});
	};

	formValidator = () => {
		const form = {
			...this.state._editProfileForm
		};
		const [updatedForm, isFormValid] = formValidator(form);
		this.setState({
			_editProfileForm: updatedForm
		});
		return isFormValid;
	};

	render() {
		const { classes } = this.props;
		const { t } = this.props;
		return (
			<BaseForm
				closeProfileScreen={this.props.closeProfileScreen}
				disabled={this.state._disableSaveButton}
				isLoading={this.props.isLoading}
				onSubmitHandler={this.onSubmitHandler}>
				{/* <Grid alignItems="center" item justify="center" sm={12} xs={12}>
					<Typography component="h1" variant="h5">
						{t('profile.edit_profile_details')}
					</Typography>
				</Grid> */}
				<Grid alignItems="center" item justify="center" sm={8} xs={12}>
					<InputLabelMobile label="Barangay*" />
					<TextField
						autoComplete="barangay"
						className={classes.displayFlex}
						error={
							!this.state._editProfileForm.barangay.isValid &&
							this.state._editProfileForm.barangay.isTouched
						}
						fullWidth
						helperText={
							!this.state._editProfileForm.barangay.isValid &&
							this.state._editProfileForm.barangay.isTouched
								? t(this.state._editProfileForm.barangay.error_text)
								: ''
						}
						id="barangay"
						// label={t(this.state._editProfileForm.barangay.placeholder)}
						placeholder={t(this.state._editProfileForm.barangay.placeholder)}
						name="barangay"
						onChange={this.handelInputChange}
						required
						value={this.state._editProfileForm.barangay.value}
						variant="outlined"
					/>
				</Grid>
				<Grid alignItems="center" item justify="center" sm={8} xs={12}>
					<InputLabelMobile label="City*" />
					<TextField
						autoComplete="city"
						className={classes.displayFlex}
						error={!this.state._editProfileForm.city.isValid && this.state._editProfileForm.city.isTouched}
						fullWidth
						helperText={
							!this.state._editProfileForm.city.isValid && this.state._editProfileForm.city.isTouched
								? t(this.state._editProfileForm.city.error_text)
								: ''
						}
						id="city"
						// label={t(this.state._editProfileForm.city.placeholder)}
						placeholder={t(this.state._editProfileForm.city.placeholder)}
						name="city"
						onChange={this.handelInputChange}
						required
						value={this.state._editProfileForm.city.value}
						variant="outlined"
					/>
				</Grid>
				<Grid alignItems="center" item justify="center" sm={8} xs={12}>
					<InputLabelMobile label="Address*" />
					<TextField
						autoComplete="address"
						className={classes.displayFlex}
						error={
							!this.state._editProfileForm.address.isValid &&
							this.state._editProfileForm.address.isTouched
						}
						fullWidth
						helperText={
							!this.state._editProfileForm.address.isValid &&
							this.state._editProfileForm.address.isTouched
								? t(this.state._editProfileForm.address.error_text)
								: ''
						}
						id="address"
						inputProps={{ maxLength: 50 }}
						// label={t(this.state._editProfileForm.address.placeholder)}
						placeholder={t(this.state._editProfileForm.address.placeholder)}
						multiline
						name="address"
						onChange={this.handelInputChange}
						required
						rows="4"
						value={this.state._editProfileForm.address.value}
						variant="outlined"
					/>
				</Grid>
				<Grid alignItems="center" item justify="center" sm={8} xs={12}>
					<InputLabelMobile label="Postal Code*" />
					<TextField
						autoComplete="postalCode"
						className={classes.displayFlex}
						error={
							!this.state._editProfileForm.postalCode.isValid &&
							this.state._editProfileForm.postalCode.isTouched
						}
						fullWidth
						helperText={
							!this.state._editProfileForm.postalCode.isValid &&
							this.state._editProfileForm.postalCode.isTouched
								? t(this.state._editProfileForm.postalCode.error_text)
								: ''
						}
						id="postalCode"
						// label={t(this.state._editProfileForm.postalCode.placeholder)}
						placeholder={t(this.state._editProfileForm.postalCode.placeholder)}
						name="postalCode"
						onChange={this.handelInputChange}
						required
						value={this.state._editProfileForm.postalCode.value}
						variant="outlined"
					/>
				</Grid>
				<Grid alignItems="center" item justify="center" sm={8} xs={12}>
					<InputLabelMobile label="Region*" />
					<Autocomplete
						popupIcon={<ExpandIcon />}
						error={
							!this.state._editProfileForm.region.isValid && this.state._editProfileForm.region.isTouched
						}
						fullwidth
						getOptionLabel={option => option.label || ''}
						id="combo-box-demo"
						name="Region"
						onChange={(event, value) => {
							this.handleStateChange(event, value);
						}}
						options={this.props.supportedStates}
						renderInput={params => (
							<TextField
								error={
									!this.state._editProfileForm.region.isValid &&
									this.state._editProfileForm.region.isTouched
								}
								{...params}
								// label={t("label.region")}
								placeholder={t('label.region')}
								name="Region"
								variant="outlined"
								required
								fullWidth
								helperText={
									!this.state._editProfileForm.region.isValid &&
									this.state._editProfileForm.region.isTouched
										? t(this.state._editProfileForm.region.error_text)
										: ''
								}
							/>
						)}
						value={this.state._editProfileForm.region.value}
					/>
				</Grid>
			</BaseForm>
		);
	}
}

export default hot(module)(withStyles(commonStyleForEditPersonalInfo)(withTranslation()(EditProfile)));
